/** @typedef {'intervene' | '15-min' | 'active' | 'history'} InterveneUserType */

export function isInterveneSessionActive(user) {
  return Boolean(user?.intervene && user?.session_start);
}

/**
 * Start/End controls are hidden on History — re-engage via template only.
 * @param {InterveneUserType | string | undefined} userType
 */
export function canShowSessionToggle(userType) {
  return userType !== 'history';
}

/**
 * @param {InterveneUserType | string | undefined} userType
 * @param {object | null | undefined} user
 */
export function canStartInterveneSession(userType, user) {
  if (!canShowSessionToggle(userType)) return false;
  if (isInterveneSessionActive(user)) return false;
  return true;
}

/**
 * @param {InterveneUserType | string | undefined} userType
 */
export function canEndInterveneSession(userType, user) {
  if (!canShowSessionToggle(userType)) return false;
  return isInterveneSessionActive(user);
}
